import { Outlet } from "react-router-dom";

export const MasterSparesPage = () => {
  return <Outlet />;
};
